<template>
  <div class="row">
    <div class="banner_box col-md-12" :style="note"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      note: {
        backgroundImage: "url(" + require("../../assets/img/banner.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      }
    };
  }
};
</script>

<style scoped>
.banner_box {
  height: 180px;
  background-size: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/header/index.vue



// WEBPACK FOOTER //
// src/components/header/index.vue